import {
  creativeIdColumn,
  creativeNameColumn,
  creativeThumbnailColumn,
  creativeTypeColumn,
} from '@/components/Grid/Columns/Creatives';
import { GRID_CHECKBOX_SELECTION_COL_DEF, type GridColDef } from '@mui/x-data-grid-pro';

const columns: GridColDef[] = [
  GRID_CHECKBOX_SELECTION_COL_DEF,
  creativeNameColumn,
  creativeIdColumn,
  creativeThumbnailColumn,
  creativeTypeColumn,
];

export default columns;
